export default "__VITE_ASSET__CfxyHBVX__"